// import React, {useState, useEffect, useRef} from "react";
// import {
//     Button,
//     Divider,
//     Grid,
//     TextField,
//     MenuItem,
//     Select,
//     InputLabel,
//     FormControl,
//     IconButton,
//     Autocomplete,
// } from "@mui/material";
// import {Add, Remove} from "@mui/icons-material";
// import patientService from "../../Services/patientService";
// import toast from "react-hot-toast";
// import {useNavigate} from "react-router-dom";
// import AddPurchaseModal from "../../Components/AddPurchaseModal";
// import productService from "../../Services/productService";
// import distributorServices from "../../Services/distributorServices";
// import moment from "moment/moment";
// import purchaseService from "../../Services/purchaseService";
// import AutoComplete from 'react-select'

// const RecordPurchases = () => {
//     const [patients, setPatients] = useState([]);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [invoiceId, setInvoiceId] = useState(null);
//     const [medicines, setMedicines] = useState([]);
//     const [distributors, setDistributors] = useState([]);
//     const [search, setSearch] = useState("");
//     const [searchDistributor, setSearchDistributor] = useState("");
//     const [isOpen, setIsOpen] = useState(false);
//     const [purchase, setPurchase] = useState({
//         supplier_id: 0,
//         amount: 0,
//         date: 0,
//         note: "",
//     });
//     const [products, setProducts] = useState([]);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [medicinesOptions, setMedicinesOptions] = useState([])
//     const [distributorsOptions, setDistributorsOptions] = useState([])

//     const navigate = useNavigate();
//     const medicineRef = useRef()

//     const handleSelectDistributor = (id) => {
//         setPurchase((p) => ({...p, supplier_id: id}));
//     };

//     const handleAddPurchase = (newProduct) => {
//         setProducts([...products, newProduct]);
//         setIsOpen(false);
//     };

//     const getPatients = async () => {
//         try {
//             const response = await patientService.fetchAllPatients();
//             setPatients(response.patients);
//         } catch (error) {
//             toast.error("Error fetching Patients");
//         }
//     };

//     const getMedicines = async () => {
//         try {
//             const response = await productService.fetchAll();
//             setMedicines(response.products);
//         } catch (error) {
//             toast.error("Error fetching Medicines");
//         }
//     };

//     const getDistributors = async () => {
//         try {
//             const response = await distributorServices.fetchAll();
//             setDistributors(response.distributors);
//         } catch (error) {
//             toast.error("Error fetching Medicines");
//         }
//     };

//     useEffect(() => {
//         if (medicines.length > 0) {
//             let array = []
//             for (const medicine of medicines) {
//                 array.push({value: medicine.id, label: `${medicine.medicine_name} (${medicine.batch_no})`})
//             }
//             setMedicinesOptions(array)
//         }
//     }, [medicines]);

//     useEffect(() => {
//         if (distributors.length > 0) {
//             let array = []
//             for (const distributor of distributors) {
//                 array.push({value: distributor.id, label: `${distributor.company} (${distributor.name})`})
//             }
//             setDistributorsOptions(array)
//         }
//     }, [distributors]);

//     useEffect(() => {
//         getPatients();
//         getMedicines();
//         getDistributors();
//         medicineRef.current.focus();
//     }, []);

//     const closeModal = () => {
//         setIsModalOpen(false);
//     };

//     const handleSelectMedicine = (id) => {
//         let medicine = medicines.filter(m => m.id === id)[0]
//         const newProduct = {
//             medicine_id: medicine.id,
//             itemCode: medicine.item_code,
//             itemName: medicine.medicine_name,
//             expiry_date: new Date().toISOString().split("T")[0],
//             batch_no: medicine.batch_no,
//             quantity: 1,
//             pack: 1,
//             box: 1,
//             unit_price: medicine.unit_price || 0,
//             packPrice: medicine.pack_price || 0,
//             sale_price: 0,
//             total_price: medicine.unit_price * medicine.quantity || 0,
//         };

//         setProducts([...products, newProduct]);
//         setSearch("");
//     };

//     const handleRemovePurchase = (index) => {
//         setProducts(products.filter((_, i) => i !== index));
//     };

//     const handleQuantity = (index, name, value) => {
//         setProducts((products) => {
//             const array = [...products];
//             let q = array[index].quantity;
//             let p = array[index].unit_price;
//             if (name === "quantity") {
//                 if (value <= 0 || isNaN(value)) {
//                     toast.error("Quantity must be greater than zero");
//                     return products;
//                 }
//                 q = value;
//             } else if (name === "unit_price") {
//                 p = value;
//             }
//             array[index] = {...array[index], [name]: value, total_price: p * q};
//             return array;
//         });
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         if (!purchase.supplier_id) {
//             toast.error("Distributor Name is required");
//             return;
//         }
//         if (!purchase.date) {
//             toast.error("Invoice Date is required");
//             return;
//         }
//         if (products.length === 0) {
//             toast.error("At least one medicine must be added");
//             return;
//         }

//         let totalAmount = 0;
//         for (let product of products) {
//             totalAmount += product.total_price;
//         }
//         let submit = {...purchase};
//         submit.amount = totalAmount;
//         submit.products = products;
//         purchaseService.create(submit).then((res) => {
//             navigate("/purchases");
//             toast.success("Purchase Created Successfully");
//         });
//     };

//     const totalPurchasePrice = products.reduce((sum, product) => sum + Number(product.total_price || 0), 0);

//     return (
//         <>
//             <form className="w-[90%] m-auto">
//                 <h1 className="m-[30px] text-center font-[700] text-[20px]">
//                     Record Medicine Purchases
//                 </h1>
//                 <div className="mt-10 pb-4">
//                     <div className="grid grid-cols-3 gap-3">
//                         <div className={`flex flex-col`}>
//                             <label className="font-semibold text-sm">Distributor</label>
//                             <AutoComplete
//                                 ref={medicineRef}
//                                 className={`w-full mt-1`}
//                                 options={distributorsOptions}
//                                 // value={selectedProduct}
//                                 onChange={(v) => handleSelectDistributor(v.value)}
//                                 placeholder="Search Distributor"
//                             />
//                         </div>

//                         <div className="flex flex-col">
//                             <label className="font-semibold text-sm">Invoice Date</label>
//                             <input
//                                 type="date"
//                                 className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1"
//                                 onChange={(e) =>
//                                     setPurchase((p) => ({
//                                         ...p,
//                                         date: moment(e.target.value).format("YYYY-MM-DD"),
//                                     }))
//                                 }
//                             />
//                         </div>
//                         <div className="flex flex-col">
//                             <label className="font-semibold text-sm">Bill Type</label>
//                             <select
//                                 className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1">
//                                 <option value="cash">Cash</option>
//                                 <option value="credit">Credit</option>
//                             </select>
//                         </div>
//                     </div>

//                     <hr className="mt-4"/>
//                     <div className="flex w-[50%] , mt-4 ">
//                         <AutoComplete
//                             ref={medicineRef}
//                             className={`w-full`}
//                             options={medicinesOptions}
//                             // value={selectedProduct}
//                             onChange={(v) => handleSelectMedicine(v.value)}
//                             placeholder="Search Medicine"
//                         />
//                     </div>
//                     <div className="mt-4">
//                         <table className="w-full border-collapse rounded-lg overflow-hidden shadow-xl shadow-gray-300">
//                             <thead>
//                             <tr className="bg-primary text-white capitalize leading-normal text-left text-xs">
//                                 <th className="p-3 w-[5%] whitespace-nowrap">Sr No.</th>
//                                 <th className="p-3 w-[10%] whitespace-nowrap">Item Code</th>
//                                 <th className="p-3 w-[15%] whitespace-nowrap">Item Name</th>
//                                 <th className="p-3 w-[10%] whitespace-nowrap">Batch No.</th>
//                                 <th className="p-3 w-[8%] whitespace-nowrap">Box</th>
//                                 <th className="p-3 w-[8%] whitespace-nowrap">Pack</th>
//                                 <th className="p-3 w-[8%] whitespace-nowrap">Units</th>
//                                 <th className="p-3 w-[8%] whitespace-nowrap">Expiry Date</th>
//                                 <th className="p-3 w-[10%] whitespace-nowrap">
//                                     Purchase Price/Unit
//                                 </th>
//                                 <th className="p-3 w-[10%] whitespace-nowrap">
//                                     Sale Price/Unit
//                                 </th>
//                                 <th className="p-3 w-[10%] whitespace-nowrap">
//                                     Total Amount
//                                 </th>
//                                 <th className="p-3 w-[8%] whitespace-nowrap">Action</th>
//                             </tr>
//                             </thead>
//                             <tbody>
//                             {products.length > 0 ? (
//                                 products.map((product, index) => (
//                                     <tr
//                                         key={index}
//                                         className="text-xs border-t border-gray-200"
//                                     >
//                                         <td className="p-3 pl-4 w-[10%] font-bold text-primary">
//                                             {index + 1}
//                                         </td>
//                                         <td className="p-3 w-[5%] font-bold">
//                                             {product.itemCode}
//                                         </td>
//                                         <td className="p-3 w-[10%] font-bold">
//                                             {product.itemName}
//                                         </td>
//                                         <td className="p-3 w-[12%]">
//                                             <input
//                                                 value={product.batch_no}
//                                                 type="text"
//                                                 name="batch_no"
//                                                 className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-20"
//                                                 onChange={(e) =>
//                                                     handleQuantity(index, e.target.name, e.target.value)
//                                                 }
//                                             />
//                                         </td>
//                                         <td className="p-3 w-[10%]">
//                                             <input
//                                                 value={product.box}
//                                                 type="number"
//                                                 name="box"
//                                                 min="0"
//                                                 onKeyDown={(e) => {
//                                                 if (e.key === '-' || e.key === 'e') {
//                                                     e.preventDefault();
//                                                 }
//                                                 }}
//                                                 className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-20"
//                                                 onChange={(e) =>
//                                                     handleQuantity(index, e.target.name, e.target.value)
//                                                 }
//                                             />
//                                         </td>
//                                         <td className="p-3 w-[8%]">
//                                             <input
//                                                 value={product.pack}
//                                                 type="number"
//                                                 name="pack"
//                                                 min="0"
//                                                 onKeyDown={(e) => {
//                                                 if (e.key === '-' || e.key === 'e') {
//                                                     e.preventDefault();
//                                                 }
//                                                 }}
//                                                 className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-20"
//                                                 onChange={(e) =>
//                                                     handleQuantity(index, e.target.name, e.target.value)
//                                                 }
//                                             />
//                                         </td>
//                                         <td className="p-3 w-[8%]">
//                                             <input
//                                                 value={product.quantity}
//                                                 type="number"
//                                                 name="quantity"
//                                                 className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-20"
//                                                 onChange={(e) =>
//                                                     handleQuantity(index, e.target.name, e.target.value)
//                                                 }
//                                             />
//                                         </td>
//                                         <td className="p-3 w-[12%]">
//                                             <input
//                                                 value={product.expiry_date}
//                                                 type="date"
//                                                 name="expiry_date"
//                                                 className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-24"
//                                                 onChange={(e) =>
//                                                     handleQuantity(index, "expiry_date", e.target.value)
//                                                 }
//                                             />
//                                         </td>
//                                         <td className="p-3 w-[8%]">
//                                             <input
//                                                 value={product.unit_price}
//                                                 type="text"
//                                                 name="unit_price"
//                                                 className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-20"
//                                                 onChange={(e) =>
//                                                     handleQuantity(index, e.target.name, e.target.value)
//                                                 }
//                                             />
//                                         </td>
//                                         <td className="p-3 w-[10%]">
//                                             <input
//                                                 value={product.sale_price}
//                                                 type="text"
//                                                 name="sale_price"
//                                                 className="bg-gray-100 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary mt-1 w-20"
//                                                 onChange={(e) =>
//                                                     handleQuantity(index, e.target.name, e.target.value)
//                                                 }
//                                             />
//                                         </td>
//                                         <td className="p-3 w-[10%]">{product.total_price}</td>
//                                         <td className="p-3 w-[10%] text-center">
//                                             <IconButton
//                                                 onClick={() => handleRemovePurchase(index)}
//                                                 color="error"
//                                             >
//                                                 <Remove/>
//                                             </IconButton>
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (

//                                 <tr>
//                                     <td colSpan="12" className="text-center p-4 text-gray-500">
//                                         No purchases added yet.
//                                     </td>
//                                 </tr>
//                             )}
//                             <tr className="bg-gray-100 font-bold">
//                                 <td colSpan="10" className="p-3 text-right text-sm">Total:</td>
//                                 <td colSpan="11" className="p-3 text-sm">{totalPurchasePrice.toFixed(2)}</td>
//                             </tr>
//                             </tbody>
//                         </table>
//                     </div>

//                     <div className="text-center my-[36px]">
//                         <Button
//                             type="submit"
//                             variant="contained"
//                             onClick={(e) => handleSubmit(e)}
//                             sx={{
//                                 backgroundColor: "#00A95B",
//                                 "&:hover": {backgroundColor: "#00A95D"},
//                             }}
//                         >
//                             Generate Purchase Invoice
//                         </Button>
//                     </div>
//                 </div>
//             </form>

//             {/* Medicine Purchase Modal */}
//             <AddPurchaseModal
//                 isOpen={isOpen}
//                 onClose={() => setIsOpen(false)}
//                 onSave={handleAddPurchase}
//             />
//         </>
//     );
// };

// export default RecordPurchases;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AddPurchaseModal from "../../Components/AddPurchaseModal";
import productService from "../../Services/productService";
import distributorServices from "../../Services/distributorServices";
import purchaseService from "../../Services/purchaseService";
import patientService from "../../Services/patientService";
import moment from "moment/moment";
import AutoComplete from "react-select";
import {
  MdLocalShipping,
  MdCalendarToday,
  MdCreditCard,
  MdDelete,
  MdArrowForward,
} from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const RecordPurchases = () => {
  const [medicines, setMedicines] = useState([]);
  const [distributors, setDistributors] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
 const [purchase, setPurchase] = useState({
  supplier_id: 0,
  amount: 0,
  date: moment().format("YYYY-MM-DD"), 
  note: "",
});
  const [products, setProducts] = useState([]);
  const [medicinesOptions, setMedicinesOptions] = useState([]);
  const [distributorsOptions, setDistributorsOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const medicineRef = useRef();

  const getMedicines = async () => {
    try {
      const response = await productService.fetchAll();
      setMedicines(response.products);
    } catch {
      toast.error("Error fetching Medicines");
    }
  };

  const getDistributors = async () => {
    try {
      const response = await distributorServices.fetchAll();
      setDistributors(response.distributors);
    } catch {
      toast.error("Error fetching Distributors");
    }
  };

  useEffect(() => {
    if (medicines.length > 0) {
      setMedicinesOptions(
        medicines.map((m) => ({
          value: m.id,
          label: `${m.medicine_name} (${m.batch_no})`,
        }))
      );
    }
  }, [medicines]);

  useEffect(() => {
    if (distributors.length > 0) {
      setDistributorsOptions(
        distributors.map((d) => ({
          value: d.id,
          label: `${d.company} (${d.name})`,
        }))
      );
    }
  }, [distributors]);

  useEffect(() => {
    getMedicines();
    getDistributors();
    medicineRef.current?.focus();
  }, []);

  const handleSelectMedicine = (id) => {
    const medicine = medicines.find((m) => m.id === id);
    if (!medicine) return;
    const newProduct = {
      medicine_id: medicine.id,
      itemCode: medicine.item_code,
      itemName: medicine.medicine_name,
      expiry_date: new Date().toISOString().split("T")[0],
      batch_no: medicine.batch_no,
      quantity: 1,
      pack: 1,
      box: 1,
      unit_price: medicine.unit_price || 0,
      packPrice: medicine.pack_price || 0,
      sale_price: 0,
      total_price: medicine.unit_price * 1 || 0,
    };
    setProducts([...products, newProduct]);
  };

  const handleRemovePurchase = (index) => {
    setProducts(products.filter((_, i) => i !== index));
  };

  const handleQuantity = (index, name, value) => {
    setProducts((prev) => {
      const array = [...prev];
      let q = array[index].quantity;
      let p = array[index].unit_price;
      if (name === "quantity") {
        if (value <= 0 || isNaN(value)) {
          toast.error("Quantity must be greater than zero");
          return prev;
        }
        q = value;
      } else if (name === "unit_price") {
        p = value;
      }
      array[index] = { ...array[index], [name]: value, total_price: p * q };
      return array;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!purchase.supplier_id) { toast.error("Distributor is required"); return; }
    if (!purchase.date) { toast.error("Invoice Date is required"); return; }
    if (products.length === 0) { toast.error("At least one medicine must be added"); return; }
    let totalAmount = products.reduce((s, p) => s + p.total_price, 0);
    let submit = { ...purchase, amount: totalAmount, products };
    setLoading(true);
    purchaseService.create(submit).then(() => {
      navigate("/purchases");
      toast.success("Purchase Created Successfully");
    }).finally(() => setLoading(false));
  };

  const totalPurchasePrice = products.reduce(
    (sum, p) => sum + Number(p.total_price || 0),
    0
  );

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "0.75rem",
      border: state.isFocused ? "1.5px solid #00A95B" : "1.5px solid #dde4ed",
      boxShadow: state.isFocused ? "0 0 0 4px rgba(0,169,91,0.1)" : "none",
      padding: "2px 4px",
      fontSize: "14px",
      fontFamily: "'DM Sans', sans-serif",
      background: "#f8fafc",
      "&:hover": { borderColor: "#00A95B" },
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "13px",
      backgroundColor: state.isSelected ? "#00A95B" : state.isFocused ? "#f0fdf7" : "white",
      color: state.isSelected ? "white" : "#0a2540",
    }),
    placeholder: (base) => ({ ...base, color: "#b0bcc9" }),
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .fade-up { animation: fadeUp 0.5s ease both; }
        .pos-input {
          background: #f8fafc;
          border: 1.5px solid #dde4ed;
          border-radius: 0.75rem;
          padding: 10px 14px;
          font-size: 14px;
          font-family: 'DM Sans', sans-serif;
          color: #0a2540;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s;
          width: 100%;
        }
        .pos-input:focus {
          border-color: #00A95B;
          box-shadow: 0 0 0 4px rgba(0,169,91,0.1);
        }
        .pos-input::placeholder { color: #b0bcc9; }
        .cell-input {
          background: #f8fafc;
          border: 1.5px solid #dde4ed;
          border-radius: 0.5rem;
          padding: 5px 8px;
          font-size: 12px;
          font-family: 'DM Sans', sans-serif;
          color: #0a2540;
          outline: none;
          width: 72px;
          transition: border-color 0.2s;
        }
        .cell-input:focus { border-color: #00A95B; box-shadow: 0 0 0 3px rgba(0,169,91,0.1); }
      `}</style>

      <div
        className="min-h-screen bg-[#f4f7fb] py-8 px-4 fade-up"
        style={{ fontFamily: "'DM Sans', sans-serif" }}
      >
        <div className="max-w-[1400px] mx-auto">

          {/* ── Page Header ── */}
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-1">
              <div
                className="w-9 h-9 rounded-xl flex items-center justify-center"
                style={{ background: "linear-gradient(135deg, #00A95B, #007a40)" }}
              >
                <MdLocalShipping size={18} className="text-white" />
              </div>
              <h1
                className="text-[#0a2540] text-[26px]"
                style={{ fontFamily: "'DM Serif Display', serif" }}
              >
                Record Medicine Purchases
              </h1>
            </div>
            <p className="text-[#8a9bb0] text-sm ml-12">
              Fill in supplier details and add medicines to generate a purchase invoice.
            </p>
          </div>

          {/* ── Purchase Info Card ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] p-6 mb-6">
            <h2 className="text-[13px] font-semibold uppercase tracking-[0.8px] text-[#4a6080] mb-4">
              Purchase Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">

              {/* Distributor */}
              <div>
                <label className="block text-[11px] font-semibold tracking-[0.7px] uppercase text-[#4a6080] mb-1.5">
                  Distributor
                </label>
                <div className="relative flex items-center">
                  <MdLocalShipping
                    size={16}
                    className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#8a9bb0] pointer-events-none z-10"
                  />
                  <div className="w-full">
                    <AutoComplete
                      ref={medicineRef}
                      styles={{
                        ...selectStyles,
                        control: (base, state) => ({
                          ...selectStyles.control(base, state),
                          paddingLeft: "28px",
                        }),
                      }}
                      options={distributorsOptions}
                      onChange={(v) => setPurchase((p) => ({ ...p, supplier_id: v.value }))}
                      placeholder="Search distributor..."
                    />
                  </div>
                </div>
              </div>

              {/* Invoice Date */}
              <div>
                <label className="block text-[11px] font-semibold tracking-[0.7px] uppercase text-[#4a6080] mb-1.5">
                  Invoice Date
                </label>
                <div className="relative flex items-center">
                 
                  <input
                type="date"
                className="pos-input pl-9"
                value={purchase.date}  
                onChange={(e) =>
                  setPurchase((p) => ({
                    ...p,
                    date: moment(e.target.value).format("YYYY-MM-DD"),
                  }))
                }
              />
                                
                </div>
              </div>

              {/* Bill Type */}
              <div>
                <label className="block text-[11px] font-semibold tracking-[0.7px] uppercase text-[#4a6080] mb-1.5">
                  Bill Type
                </label>
                <div className="relative flex items-center">
                 
                  <select className="pos-input pl-9 cursor-pointer">
                    <option value="cash">Cash</option>
                    <option value="credit">Credit</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* ── Medicine Search Card ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] p-6 mb-6">
            <h2 className="text-[13px] font-semibold uppercase tracking-[0.8px] text-[#4a6080] mb-4">
              Add Medicines
            </h2>
            <div className="w-full md:w-1/2">
              <AutoComplete
                styles={selectStyles}
                options={medicinesOptions}
                onChange={(v) => handleSelectMedicine(v.value)}
                placeholder="Search medicines by name..."
              />
            </div>
          </div>

          {/* ── Products Table Card ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] overflow-hidden mb-6">
            <div className="px-6 py-4 border-b border-[#eef1f6] flex items-center justify-between">
              <h2 className="text-[13px] font-semibold uppercase tracking-[0.8px] text-[#4a6080]">
                Purchase Items
              </h2>
              {products.length > 0 && (
                <span className="text-[11px] font-semibold bg-[#f0fdf7] text-[#00A95B] border border-[#c6f0de] px-2.5 py-1 rounded-full">
                  {products.length} item{products.length !== 1 ? "s" : ""}
                </span>
              )}
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead>
  <tr style={{ background: '#00A95B' }}>  
                      {["Sr.", "Item Code", "Item Name", "Batch No.", "Box", "Pack", "Units", "Expiry", "Purchase Price", "Sale Price", "Total", ""].map((h) => (
                      <th
                        key={h}
                        className="px-3 py-3.5 text-[11px] font-semibold uppercase tracking-[0.6px] text-white whitespace-nowrap"
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {products.length > 0 ? (
                    products.map((product, index) => (
                      <tr
                        key={index}
                        className={`text-[13px] border-b border-[#f0f4f8] transition-colors ${
                          index % 2 === 0 ? "bg-white" : "bg-[#fafbfd]"
                        } hover:bg-[#f0fdf7]`}
                      >
                        <td className="px-3 py-3 font-bold text-[#00A95B]">{index + 1}</td>
                        <td className="px-3 py-3 font-medium text-[#4a6080]">{product.itemCode}</td>
                        <td className="px-3 py-3 font-semibold text-[#0a2540] whitespace-nowrap">{product.itemName}</td>

                        {/* Batch No */}
                        <td className="px-3 py-3">
                          <input
                            value={product.batch_no}
                            type="text"
                            name="batch_no"
                            className="cell-input"
                            onChange={(e) => handleQuantity(index, e.target.name, e.target.value)}
                          />
                        </td>

                        {/* Box */}
                        <td className="px-3 py-3">
                          <input
                            value={product.box}
                            type="number"
                            name="box"
                            min="0"
                            className="cell-input"
                            onKeyDown={(e) => { if (e.key === "-" || e.key === "e") e.preventDefault(); }}
                            onChange={(e) => handleQuantity(index, e.target.name, e.target.value)}
                          />
                        </td>

                        {/* Pack */}
                        <td className="px-3 py-3">
                          <input
                            value={product.pack}
                            type="number"
                            name="pack"
                            min="0"
                            className="cell-input"
                            onKeyDown={(e) => { if (e.key === "-" || e.key === "e") e.preventDefault(); }}
                            onChange={(e) => handleQuantity(index, e.target.name, e.target.value)}
                          />
                        </td>

                        {/* Units */}
                        <td className="px-3 py-3">
                          <input
                            value={product.quantity}
                            type="number"
                            name="quantity"
                            className="cell-input"
                            onChange={(e) => handleQuantity(index, e.target.name, e.target.value)}
                          />
                        </td>

                        {/* Expiry */}
                        <td className="px-3 py-3">
                          <input
                            value={product.expiry_date}
                            type="date"
                            name="expiry_date"
                            className="cell-input"
                            style={{ width: "110px" }}
                            onChange={(e) => handleQuantity(index, "expiry_date", e.target.value)}
                          />
                        </td>

                        {/* Purchase Price */}
                        <td className="px-3 py-3">
                          <input
                            value={product.unit_price}
                            type="text"
                            name="unit_price"
                            className="cell-input"
                            onChange={(e) => handleQuantity(index, e.target.name, e.target.value)}
                          />
                        </td>

                        {/* Sale Price */}
                        <td className="px-3 py-3">
                          <input
                            value={product.sale_price}
                            type="text"
                            name="sale_price"
                            className="cell-input"
                            onChange={(e) => handleQuantity(index, e.target.name, e.target.value)}
                          />
                        </td>

                        {/* Total */}
                        <td className="px-3 py-3 font-bold text-[#0a2540] whitespace-nowrap">
                          Rs. {parseFloat(product.total_price || 0).toFixed(2)}
                        </td>

                        {/* Delete */}
                        <td className="px-3 py-3">
                          <button
                            type="button"
                            onClick={() => handleRemovePurchase(index)}
                            className="w-7 h-7 flex items-center justify-center rounded-lg bg-red-50 text-red-400 hover:bg-red-100 hover:text-red-600 transition-colors"
                          >
                            <MdDelete size={15} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-center py-12 text-[#b0bcc9]">
                        <div className="flex flex-col items-center gap-2">
                          <MdLocalShipping size={32} className="text-[#dde4ed]" />
                          <span className="text-sm">No medicines added yet. Search above to add items.</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* ── Summary + Submit ── */}
          <div className="bg-white rounded-2xl shadow-sm border border-[#eef1f6] p-6">
            <h2 className="text-[13px] font-semibold uppercase tracking-[0.8px] text-[#4a6080] mb-5">
              Purchase Summary
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
              <SummaryCard label="Total Items" value={products.length} color="#0a2540" bg="#f4f7fb" border="border-[#eef1f6]" />
              <SummaryCard
                label="Total Amount"
                value={`Rs. ${totalPurchasePrice.toFixed(2)}`}
                color="#00A95B"
                bg="#f0fdf7"
                border="border-emerald-100"
              />
            </div>

            <div className="flex justify-end">
              <button
                type="button"
                onClick={handleSubmit}
                disabled={loading}
                className="flex items-center gap-2.5 px-8 py-3.5 rounded-xl text-white text-[15px] font-semibold tracking-[0.3px] transition-all disabled:opacity-60 disabled:cursor-not-allowed hover:enabled:-translate-y-px"
                style={{
                  background: "linear-gradient(135deg, #00A95B 40%, #007a40 100%)",
                  boxShadow: "0 4px 20px rgba(0,169,91,0.35)",
                  fontFamily: "'DM Sans', sans-serif",
                }}
              >
                {loading ? (
                  <>
                    <AiOutlineLoading3Quarters size={17} className="animate-spin" />
                    Generating…
                  </>
                ) : (
                  <>
                    <MdArrowForward size={18} />
                    Generate Purchase Invoice
                  </>
                )}
              </button>
            </div>
          </div>

        </div>
      </div>

      <AddPurchaseModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSave={(p) => { setProducts([...products, p]); setIsOpen(false); }}
      />
    </>
  );
};

/* ── Summary Card ── */
const SummaryCard = ({ label, value, color, bg, border }) => (
  <div className={`rounded-xl p-4 flex flex-col gap-1 border ${border}`} style={{ background: bg }}>
    <span className="text-[11px] font-semibold uppercase tracking-[0.7px] text-[#8a9bb0]">{label}</span>
    <span className="text-[18px] font-bold" style={{ color, fontFamily: "'DM Serif Display', serif" }}>
      {value}
    </span>
  </div>
);

export default RecordPurchases;